<template>
	<div>

		<el-card style="margin-top: 0px !important;">
			<el-tabs v-model="activeName" type="card" v-loading="loading">
				<!-- <el-tab-pane  label="订单信息" name="Order"> -->
				<el-form :inline="true" :model="Info" size="mini" label-width="70px">
					<el-row>
						<!-- 	<el-col :span="6">
								<el-form-item label="订单号">
									<el-input v-model="Info.F_OrderCode" readonly="readonly"></el-input>
								</el-form-item>
							</el-col> -->

						<el-col :span="6">
							<el-form-item label="订货单位">
								<el-input v-model="Info.F_CustomerName" readonly="readonly"></el-input>
							</el-form-item>
						</el-col>

						<el-col :span="11">
							<el-form-item label="备注">
								<el-input v-model="Info.Remark" style="width:450px;"></el-input>
							</el-form-item>
						</el-col>
						<el-button type="success" @click="OpenProxuanze" size="mini" v-if="Add">新增商品</el-button>
						<el-button type="success" @click="OpenHdPro" size="mini" v-if="hdAdd&&ishd">新增集采商品</el-button>
						<el-button type="primary" @click="saveOrder" size="mini" v-loading="saveloaing">保存订单</el-button>

						<!-- <div style="display: inline-block;margin-left: 5px;margin-right: 5px;">
							<el-upload ref="upload" action="/wm/upload/" :show-file-list="false" :on-change="readExcel" :auto-upload="false">
								<el-button slot="trigger" icon="el-icon-upload" size="mini" type="primary">
									上传文件
								</el-button>
							</el-upload>
						</div> -->
						<el-button type="danger" @click="back" size="mini">关闭页面</el-button>
					</el-row>
					<!-- <el-row style="margin-top: -20px !important;">
						<el-button type="success" @click="OpenPro" size="mini">新增商品</el-button>
						<div style="display: inline-block;margin-left: 5px;">
							<el-upload ref="upload" action="/wm/upload/" :show-file-list="false" :on-change="readExcel" :auto-upload="false">
								<el-button slot="trigger" icon="el-icon-upload" size="mini" type="primary">
									上传文件
								</el-button>
							</el-upload>
						</div>
					</el-row> -->
				</el-form>
				<!-- 表格 -->
				<el-table ref="ordertable" :height="TableHeight" size="mini" :stripe="true" :data="ProList" show-summary
					:summary-method="getSummaries" :row-style="{height: '0'}" :cell-style="{padding: '0'}" border
					:header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">

					<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
						<template slot-scope="scope">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 50px;"></i>
								</div>
							</el-image>
						</template>
					</el-table-column>
					<el-table-column prop="ProductName" label="编码/名称/整件规格/规格型号" align="center" min-width="300px"
						show-overflow-tooltip>
						<template slot-scope="scope">
							<a href="javascript:;" style="text-center: center;">
								<i
									style="font-style:normal;color: #004085;height: ;">{{ scope.row.ProductCode }}</i><br>
								<i style="font-style:normal;color: #004085;">{{ scope.row.ProductName }}</i><br>
								<i style="font-style:normal;color: #004085;">{{scope.row.整件规格}}</i><br>
								<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i>
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="ProPrice" label="优惠" align="center" min-width="200px" show-overflow-tooltip>
						<template slot-scope="scope">
							<div style="text-decoration:underline;cursor:pointer;">
								<span v-if="scope.row.QX_TJ=='True'&& scope.row.OrderType!='QX_QD'">特价起订量为
									{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.onenum)}}
									件,特价 {{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}} 元</span>
								<div
									v-else-if="(scope.row.QX_QD=='True'&& scope.row.OrderType=='QX_QD')||scope.row.spcode!=''">
									<span style="display: block"
										v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，特价{{u.lvprice}}元&nbsp;</span>
								</div>
								<div
									v-else-if="(scope.row.QX_PT=='True'&& scope.row.OrderType=='QX_PT')||scope.row.spcode!=''">
									<span style="display: block"
										v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，特价{{u.lvprice}}元&nbsp;</span>
								</div>
								<!--<div v-else-if="scope.row.QX_QD=='True'&& scope.row.OrderType=='QX_QD'" style="white-space:pre">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，特价{{u.lvprice}}元&#10;</div>-->
								<div v-else-if="scope.row.lvprice&&(scope.row.spcode!=''||scope.row.spcode!=null)"
									style="white-space:pre"><span style="display: block"
										v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，单价{{u.lvprice}}元&nbsp;</span>
								</div>
								<span v-else>无</span>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="ProductName" label="规格型号" align="center" min-width="100px" show-overflow-tooltip>
						<template slot-scope="scope">
							<div style="text-decoration:underline;cursor:pointer;">
							<a href="javascript:;" style="text-center: center;">
	
								<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i><br>
							</a>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column prop="stdd" label="单位箱规" align="center" min-width="70px" show-overflow-tooltip>
						<template slot-scope="scope">
								<div style="text-decoration:underline;cursor:pointer;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.Unit }}</i><br>
							<i style="font-style:normal;color: #004085;">1件={{ parseInt(scope.row.onenum) }}{{ scope.row.Unit }}</i>
							</div>
						</template>
					</el-table-column> -->

					<el-table-column prop="Number" label="件数" align="center" min-width="80px">
						<template slot-scope="scope">
							<div>
								<el-input v-model="scope.row.Number" @change="detailEdit(scope.row,'Number')">
								</el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="sumnum" label="总数量" align="center" min-width="100px">
						<template slot-scope="scope">
							<div v-if="scope.row.isCX=='True'">


								<div style="float: left;width: 80px;">
									<el-input style="width: 70px;" v-model="scope.row.sumnum"
										@change="detailEdit(scope.row,'sumnum')"></el-input>
								</div>
								<div style="float: left;line-height: 40px;"> {{scope.row.Unit}}</div>
							</div>
							<div v-else>
								{{scope.row.sumnum+scope.row.Unit}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ProPrice" label="单价" align="center" min-width="80px">
						<template slot-scope="scope">
							<div>
								<!--<i style="font-style:normal;color: #004085;">{{ parseFloat(scope.row.YProPrice).toFixed(2)}}</i><br>-->
								<i
									style="font-style:normal;color: #004085;">{{ parseFloat(scope.row.ProPrice).toFixed(2)}}</i><br>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="YProPrice" label="销售单价" align="center" width="100">
							<template slot-scope="scope">
								<div>
									{{ parseFloat(scope.row.YProPrice).toFixed(2)}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="ProPrice" label="优惠单价" align="center" width="100">
							<template slot-scope="scope">
								<div>
									{{ parseFloat(scope.row.ProPrice).toFixed(2)}}
								</div>
							</template>
						</el-table-column> -->
					<el-table-column prop="TotalPrice" label="金额" align="center" min-width="80px">
						<template slot-scope="scope">
							<div>
								{{ parseFloat(parseFloat(scope.row.TotalPrice).toFixed(2))}}
							</div>
						</template>
					</el-table-column>
					<!-- 	<el-table-column prop="onetiji" label="单件体积" align="center" width="100">
						</el-table-column>
						<el-table-column prop="suntiji" label="总体积" align="center" width="100">
						</el-table-column> -->

					<!-- <el-table-column prop="onetiji" label="总体积" align="center" width="60">
						<template slot-scope="scope">
							<a href="javascript:;" style="text-center: center;">
							
								
					
							</a>
						</template>
					</el-table-column> -->
					<el-table-column prop="Remarks" label="备注" min-width="150px" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-input v-model="scope.row.Remarks">
							</el-input>
						</template>
					</el-table-column>

					<el-table-column label="下单类型" min-width="90px">
						<template slot-scope="scope">
							<el-select :disabled="true" size="mini" v-model="scope.row.OrderType" placeholder="请选择"
								@change="OrderTypeChange(scope.row)">
								<el-option size="mini" v-for="item in options" :key="item.key" :label="item.label"
									:value="item.value" :disabled="scope.row[item.key]=='True'? false:true">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="onetiji" label="体积" align="center" min-width="60px" show-overflow-tooltip>
						<template slot-scope="scope">
							<div style="text-decoration:underline;cursor:pointer;">
								<a href="javascript:;" style="text-center: center;">
									<i style="font-style:normal;color: #004085;">单{{ scope.row.onetiji }}</i><br>
									<i style="font-style:normal;color: #004085;">总{{ scope.row.suntiji }}</i><br>

								</a>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="action" label="操作" min-width="60" fixed="right">
						<template slot-scope="scope">
							<el-button @click.native.prevent="deletePro(scope.row)" type="text" size="small">
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<el-form :data="Info" :inline="true" :model="Info" size="mini" label-width="75px"
					style="margin-top: 20px;">
					<el-row>
						<el-col :span="6">
							<el-form-item label="账户余额">
								<el-input v-model="Info.txtzhanghumoney" readonly="readonly"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="8">
								<el-form-item label="制单人">
									<el-input v-model="Info.Cmaker" readonly="readonly"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="制单日期">
									<el-input v-model="Info.Cdate" readonly="readonly"></el-input>
								</el-form-item>
							</el-col> -->
						<el-col :span="6">
							<el-form-item label="订单金额">
								<el-input v-model="Info.TotalMoney" readonly="readonly"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="使用返利">
								<el-input v-model="Info.flmoney" readonly="readonly"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="支付金额">
								<el-input v-model="Info.paymoney" readonly="readonly"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

				<!-- 	</el-tab-pane> -->
			</el-tabs>

		</el-card>
		<el-dialog :visible.sync="ProVisible" width="100%" top="0" :modal="false">
			<el-form :inline="true" style="margin-top: -5px;margin-bottom: -10px;">
				<el-form-item>
					<span>关键词:</span>
					<el-input size="mini" v-model="keyword" style="width: 200px;margin:0 10px;"></el-input>
					<el-button size="mini" type="primary" @click="(pagination.page=1,onSubmit())"
						:disabled="!loading==0">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-select size="mini" v-model="value" placeholder="请选择" style="width:120px" @change="quanxian">
						<el-option v-for="item in prooptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" type="danger" style="margin-bottom: 10px;" @click="ProVisible = false">
						关闭并回到订单</el-button>
				</el-form-item>
			</el-form>
			<el-table :height="addproheight" size="mini" :stripe="true" v-loading="loading" :data="AddPro"
				style="width: 100%" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">

				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 60px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="F_ClassName" label="编码/名称/整件规格/规格型号" min-width="300px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
							style="text-center: center;">
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ProductCode }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ClassName }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.整件规格 }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_SpecText }}</i><br>
						</a>
					</template>
				</el-table-column>

				<el-table-column prop="lv" label="优惠" align="center" min-width="200px" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.QX_TJ&&scope.row.TJsum!=null&& value!='QX_QD'">特价起订量为
							{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.F_UnitRate)}}
							件,特价 {{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}} 元</span>
						<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_QD'"
							style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
						</div>
						<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_PT'"
							style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
						</div>
						<span v-else>无</span>
					</template>
				</el-table-column>

				<el-table-column prop="price" label="单价" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ scope.row.price|showPrice() }}
					</template>
				</el-table-column>
				<el-table-column label="件数" min-width="139px" align="center">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.num" :min="1" :max="999999" @change="changenum(scope.row)"
							size="mini" style="width: 115px;"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="TotalNum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">

						{{ parseFloat((scope.row.num*scope.row.F_UnitRate).toFixed(2)) }}{{scope.row.F_UnitText}}
					</template>
				</el-table-column>
				<el-table-column prop="TotalMoney" label="总金额" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ (scope.row.num*scope.row.F_UnitRate*scope.row.price).toFixed(2)|showPrice() }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="CustPrice" label="库存" align="center" width="80px">
					<template slot-scope="scope">
						{{ scope.row.F_Stock }}
					</template>
				</el-table-column> -->
				<el-table-column prop="action" label="操作" min-width="80">
					<template slot-scope="scope">
						<el-button @click.native.prevent="SavePro(scope.row)" type="text" size="mini"
							:loading='scope.row.F_Disabled'>
							选入产品
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top: 0px;" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10,20,50,100]"
				:page-size="pagination.rows" layout="total, sizes, prev, pager, next, jumper"
				:total="pagination.records">
			</el-pagination>

		</el-dialog>
		<el-dialog :visible.sync="HdProVisible" width="100%" top="0" :modal="false">
			<el-form :inline="true" style="margin-top: -5px;margin-bottom: -10px;">
				<el-form-item>
					<span>关键词:</span>
					<el-input size="mini" v-model="Hdkeyword" style="width: 200px;margin:0 10px;"></el-input>
					<el-button size="mini" type="primary" @click="(Hdpagination.page=1,onHdSubmit())"
						:disabled="!loading==0">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="mini" type="danger" style="margin-bottom: 10px;" @click="HdProVisible = false">
						关闭并回到订单</el-button>
				</el-form-item>
				<el-form-item>
					<span style="color: red;margin-left: 100px;font-size: 16px !important;">蜂窝大板大板集采活动专用页面</span>
				</el-form-item>
			</el-form>
			<el-table :height="addproheight" size="mini" :stripe="true" v-loading="loading" :data="AddHdPro"
				style="width: 100%" :header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">

				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 60px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="F_ClassName" label="编码/名称/整件规格/规格型号" min-width="300px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
							style="text-center: center;">
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ProductCode }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_ClassName }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.整件规格 }}</i><br>
							<i style="font-style:normal;color: #000000;">{{ scope.row.F_SpecText }}</i><br>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="lv" label="优惠" align="center" min-width="200px">
					<template slot-scope="scope">
						<div v-if="scope.row.lvprice" style="white-space:pre"><span style="display: block"
								v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</br></span>
						</div>
						<span v-else>无</span>
					</template>
				</el-table-column>

				<el-table-column prop="price" label="单价" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ scope.row.price|showPrice() }}
					</template>
				</el-table-column>
				<el-table-column label="件数" min-width="139px" align="center">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.num" :min="1" :max="999999" @change="changehdnum(scope.row)"
							size="mini" style="min-width: 115px;"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="TotalNum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ parseFloat((scope.row.num*scope.row.F_UnitRate).toFixed(2)) }}
					</template>
				</el-table-column>
				<el-table-column prop="TotalMoney" label="总金额" align="center" min-width="80px">
					<template slot-scope="scope">
						{{ (scope.row.num*scope.row.F_UnitRate*scope.row.price).toFixed(2)|showPrice() }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="CustPrice" label="库存" align="center" width="80px">
					<template slot-scope="scope">
						{{ scope.row.F_Stock }}
					</template>
				</el-table-column> -->
				<el-table-column prop="action" label="操作" min-width="80">
					<template slot-scope="scope">
						<el-button @click.native.prevent="SaveHdPro(scope.row)" type="text" size="mini"
							:loading='scope.row.F_Disabled'>
							选入产品
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top: 0px;" @size-change="hdhandleSizeChange"
				@current-change="hdhandleCurrentChange" :current-page="Hdpagination.page" :page-sizes="[10,20,50,100]"
				:page-size="Hdpagination.rows" layout="total, sizes, prev, pager, next, jumper"
				:total="Hdpagination.records">
			</el-pagination>

		</el-dialog>


		<el-dialog title="配套购买提醒" :visible.sync="ProMatchVisible" width="100%" top="0" :before-close="handleClose"
			:modal="false">
			<el-table :height="addproheight" :stripe="true" :data="ProMatch" ref="matchtable"
				style="width: 100%;margin-bottom: 20px;" row-key="ProductCode" border default-expand-all
				selection-change="handleSelectionChange" @select="select" @select-all="selectall"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				:header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="chzt" width="125px" label="说明">
					<template slot-scope="scope">
						<span v-if="scope.row.isgou=='True'" style="color: red;">
							{{scope.row.chzt}}
						</span>
						<span v-else>
							{{scope.row.chzt}}
						</span>
					</template>
				</el-table-column>


				<el-table-column prop="OrderType" label="下单类型" align="center" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.OrderType=='QX_PT'">
							普通
						</span>
						<span v-else-if="scope.row.OrderType=='QX_DS'">
							电商
						</span>
						<span v-else-if="scope.row.OrderType=='QX_QD'">
							渠道
						</span>
						<span v-else-if="scope.row.OrderType=='QX_TJ'">
							特价
						</span>
						<!-- <span v-else-if="scope.row.OrderType=='QX_PJ'">
							配件
						</span>
						<span v-else-if="scope.row.OrderType=='QX_WL'">
							物料
						</span> -->
					</template>
				</el-table-column>
				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" label="编码/名称/整件规格/规格型号" align="center" min-width="360px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductCode }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductName }}</i><br>
							<i style="font-style:normal;color: #004085;">{{scope.row.整件规格}}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i><br>
						</a>
					</template>
				</el-table-column>

				<el-table-column prop="Number" label="件数" align="center" min-width="139px">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.Number" @change="matchEdit(scope.row,'Number')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sumnum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.sumnum" @change="matchEdit(scope.row,'sumnum')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ProPrice" label="销售单价" align="center" min-width="85px">
					<template slot-scope="scope">
						<div>
							<i
								style="font-style:normal;color: #004085;">{{ parseFloat(scope.row.ProPrice).toFixed(2)}}</i><br>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="TotalPrice" label="金额" align="center" min-width="100px">
					<template slot-scope="scope">
						<div>
							{{ parseFloat(scope.row.TotalPrice).toFixed(2)}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="onetiji" label="体积" align="center" min-width="80px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">单:{{ scope.row.onetiji }}</i><br>
							<i style="font-style:normal;color: #004085;">总:{{ scope.row.suntiji }}</i><br>
						</a>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="SaveProMatch" size="mini">选入配套产品</el-button>
				<!-- <el-button @click="ProMatchVisible = false" size="mini">关 闭</el-button> -->
				<el-button type="primary" @click="SaveProMatch" size="mini">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="龙骨购买提醒" :visible.sync="peitiVisible" width="100%" top="0" :before-close="handleClose"
			:modal="false">
			<el-table :height="addproheight" :stripe="true" :data="peitiData" ref="peititable"
				style="width: 100%;margin-bottom: 20px;" row-key="ProductCode" border default-expand-all>
				<el-table-column type="selection" width="40">
				</el-table-column>
				<el-table-column prop="OrderType" label="下单类型" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.OrderType=='QX_PT'">
							普通
						</span>
						<span v-else-if="scope.row.OrderType=='QX_DS'">
							电商
						</span>
						<span v-else-if="scope.row.OrderType=='QX_QD'">
							渠道
						</span>
						<span v-else-if="scope.row.OrderType=='QX_TJ'">
							特价
						</span>
						<!-- <span v-else-if="scope.row.OrderType=='QX_PJ'">
							配件
						</span>
						<span v-else-if="scope.row.OrderType=='QX_WL'">
							物料
						</span> -->
					</template>
				</el-table-column>
				<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<el-image
								:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
								class="img">
								<div slot="error">
									<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
								</div>
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" label="编码/名称/整件规格/规格型号" align="center" min-width="160px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductCode }}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.ProductName }}</i><br>
							<i style="font-style:normal;color: #004085;">{{scope.row.整件规格}}</i><br>
							<i style="font-style:normal;color: #004085;">{{ scope.row.Standard }}</i><br>
						</a>
					</template>
				</el-table-column>

				<el-table-column prop="Number" label="件数" align="center" min-width="80px">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.Number" @change="peitiEdit(scope.row,'Number')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sumnum" label="总数量" align="center" min-width="80px">
					<template slot-scope="scope">
						<div>
							<el-input size="mini" v-model="scope.row.sumnum" @change="peitiEdit(scope.row,'sumnum')"
								:disabled="scope.row.children!=undefined"></el-input>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="Sumstockbalance" label="需求总数量" min-width="100px" align="center">
				</el-table-column>
				<el-table-column prop="ProPrice" label="销售单价" align="center" width="85">
					<template slot-scope="scope">
						<div>
							<i
								style="font-style:normal;color: #004085;">{{ parseFloat(parseFloat(scope.row.ProPrice).toFixed(2))}}</i><br>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="TotalPrice" label="金额" align="center" min-width="100px">
					<template slot-scope="scope">
						<div>
							{{ parseFloat(scope.row.TotalPrice).toFixed(2)}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="onetiji" label="体积" align="center" min-width="80px">
					<template slot-scope="scope">
						<a href="javascript:;" style="text-center: center;">
							<i style="font-style:normal;color: #004085;">单:{{ scope.row.onetiji }}</i><br>
							<i style="font-style:normal;color: #004085;">总:{{ scope.row.suntiji }}</i><br>
						</a>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="SavePeiti">选入龙骨并保存订单</el-button>
				<el-button size="mini" @click="peitiVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: "AddOrder",
		props: {
			order: {},
		},
		data() {
			return {
				saveloaing: false,
				Add: true,
				hdAdd: true,
				issaved: 0,
				loading: 0,
				Info: {},
				ProList: [],
				ProVisible: false,
				SelectPro: [], //选中的商品
				AddPro: [], //商品列表
				AddHdPro: [], //商品列表
				delPro: [], //删除列表
				activeName: 'Order',
				pagination: {
					rows: 10,
					page: 1
				},
				Hdpagination: {
					rows: 10,
					page: 1
				},
				HdProVisible: false,
				keyword: "",
				Hdkeyword: "",
				prooptions: [{
						value: 'QX_PT',
						label: '普通',
						key: 'QX_PT',
					}, {
						value: 'QX_QD',
						label: '渠道',
						key: 'QX_QD',
					}, {
						value: 'QX_DS',
						label: '电商',
						key: 'QX_DS',
					}, {
						value: 'QX_TJ',
						label: '特价',
						key: 'QX_TJ',
					},
					// {
					// 	value: 'QX_PJ',
					// 	label: '配件',
					// 	key: 'QX_PJ',
					// }, {
					// 	value: 'QX_WL',
					// 	label: '物料',
					// 	key: 'QX_WL',
					// },
					{
						value: 'QX_YT',
						label: '阳台',
						key: 'QX_YT',
					}
				],
				options: [{
						value: 'QX_PT',
						label: '普通',
						key: 'QX_PT',
					}, {
						value: 'QX_QD',
						label: '渠道',
						key: 'QX_QD',
					}, {
						value: 'QX_DS',
						label: '电商',
						key: 'QX_DS',
					}, {
						value: 'QX_TJ',
						label: '特价',
						key: 'QX_TJ',
					}, 
					// {
					// 	value: 'QX_PJ',
					// 	label: '配件',
					// 	key: 'QX_PJ',
					// }, {
					// 	value: 'QX_WL',
					// 	label: '物料',
					// 	key: 'QX_WL',
					// }, 
					{
						value: 'QX_HD',
						label: '活动',
						key: 'QX_HD',
					},
					{
						value: 'QX_YT',
						label: '阳台',
						key: 'QX_YT',
					}
				],
				value: "QX_PT",
				ProMatchVisible: false,
				ProMatch: [], //配套产品
				ids: [], //传入ID
				proValue: [], //传入类型
				peitiVisible: false,
				peitiData: [], //龙骨产品信息
				tableheight: 500,
				TableHeight: 500,
				addproheight: '400px',
				ishd: true,
				Yishd: true
			}
		},
		created() {
			this.TableHeight = (document.documentElement.clientHeight - 230) + "px"
			this.addproheight = (document.documentElement.clientHeight - 130) + "px"
			window.onresize = () => {
				this.Tableheight = (document.documentElement.clientHeight - 230) + "px"
				//this.opencinvheight=(document.documentElement.clientHeight - 155) + "px"
				this.addproheight = (document.documentElement.clientHeight - 130) + "px"
			}
			/*if (this.$route.params.ids != undefined) {
				this.ids = this.$route.params.ids
				this.proValue = this.$route.params.proValue
			}*/
			this.onload()

			alert("温馨提示：下单时请留意总数量的数值与单位以及显示提示，谢谢！");
		},
		updated() {
			this.$nextTick(() => {
				this.$refs['ordertable'].doLayout();
			})
		},
		watch: {
			"order": {
				handler() {
					this.onload();
				}
			}
		},
		beforeDestroy() {

		},
		methods: {
			onload() {
				this.ids = this.order.ids
				this.proValue = this.order.proValue

				this.OrderDetail()
			},
			//计算价格
			count() {
				var sum = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i]
						.onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.ProPrice)).toFixed(2)
					this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.YProPrice)).toFixed(
						2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji))
						.toFixed(2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2)
			},
			readExcel(file) {
				var persons
				const fileReader = new FileReader();
				fileReader.onload = (ev) => {
					console.log(ev)
					try {
						const data = ev.target.result;
						const workbook = XLSX.read(data, {
							type: 'binary',
						});
						console.log(WorkBook)
						for (let sheet in workbook.Sheets) {
							const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
						}
					} catch (e) {
						this.$message.warning('文件类型不正确！');
						return false;
					}
					var fromTo = '';
					// 遍历每张表读取
					for (var sheet in workbook.Sheets) {
						if (workbook.Sheets.hasOwnProperty(sheet)) {
							fromTo = workbook.Sheets[sheet]['!ref'];
							console.log(fromTo);
							persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
							// break; // 如果只取第一张表，就取消注释这行
						}
					}
				};

				fileReader.readAsBinaryString(file.raw);
				//console.log(persons)
			},
			//返回订单列表
			back() {
				/*this.$confirm('是否退出订单新增?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push('/order/promote22232')
				}).catch(() => {

				});*/
				this.order.ids = ""
				this.order.proValue = ""
				this.order.value = ""
				this.ProList = []
				this.Add = true
				this.hdAdd = true
				this.value = "QX_PT"
				this.keyword = ""
				this.Hdkeyword = ""
				this.Info.spcode = null
				this.$emit("closeAddOrder", false);
			},
			select(selection, row) {
				var isselect = 0;
				var that = this
				selection.forEach(el => {
					if (row.ProductCode == el.ProductCode) {
						isselect = 1
					}
				})
				if (isselect == 1) {
					if (row.children != undefined) {
						row.children.forEach(i => {
							that.$refs.matchtable.toggleRowSelection(i, true)
						})
					}
				} else {
					if (row.children != undefined) {
						row.children.forEach(i => {
							that.$refs.matchtable.toggleRowSelection(i, false)
						})
					}
				}
			},
			selectall(selection) {
				var that = this
				selection.forEach(el => {
					if (el.children == undefined) {
						that.$refs.matchtable.toggleRowSelection(el, false)
					}
				})

				if (selection.length != 0) {
					selection.forEach(el => {
						if (el.children != undefined) {
							el.children.forEach(i => {
								that.$refs.matchtable.toggleRowSelection(i, true)
							})
						}
					})
				}

			},
			//更改配套产品数量
			matchEdit(row, type) {
				if (type == "sumnum") {
					row.Number = parseFloat((parseFloat(row.sumnum) / parseFloat(row.onenum)).toFixed(2))

				} else {
					row.sumnum = parseFloat((parseFloat(row.onenum) * parseFloat(row.Number)).toFixed(2))
				}
				row.sumnum = parseFloat((parseFloat(row.Number) * parseFloat(row.onenum)).toFixed(2))
				row.TotalPrice = (parseFloat(row.Number) * parseFloat(row.onenum) *
					parseFloat(row.ProPrice)).toFixed(2)
				row.YTotalPrice = (parseFloat(row.Number) * parseFloat(row.onenum) *
					parseFloat(row.YProPrice)).toFixed(2)
				row.suntiji = (parseFloat(row.Number) * parseFloat(row.onetiji)).toFixed(2)
				for (var i = 0; i < this.ProMatch.length; i++) {
					this.ProMatch[i].sumnum = parseFloat((parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i]
						.onenum)).toFixed(
						2))
					this.ProMatch[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.ProPrice)).toFixed(
						2)
					this.ProMatch[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i]
						.YProPrice)).toFixed(
						2)
					this.ProMatch[i].suntiji = (parseFloat(this.ProMatch[i].Number) * parseFloat(this.ProMatch[i].onetiji))
						.toFixed(2)
				}
			},
			//保存配套产品至订单中
			SaveProMatch() {
				var that = this
				var hasnum = 0

				this.ProMatch.forEach(el => {
					if (el.children != undefined) {
						el.children.forEach(cd => {
							if (cd.sumnum == 0 && cd.isgou == 'True') {
								hasnum++;
								this.$message({
									message: '请填写必须购买产品(标红色)的数量!',
									type: 'error'
								});
								return
							} else if (cd.sumnum > 0) {
								var issame = 0;
								for (var i = 0; i < this.ProList.length; i++) {
									if (this.ProList[i].ProductCode == cd.ProductCode) {
										issame = 1
										break
									}
									if (issame == 0) {
										this.ProList.push(cd)
									}
								}
							}
						});
					}
				});
				if (hasnum == 0) {
					this.ProMatchVisible = false;
				}
			},
			//更改配提产品数量
			peitiEdit(row, type) {
				if (type == "sumnum") {
					row.Number = parseFloat((parseFloat(row.sumnum) / parseFloat(row.onenum)).toFixed(2))

				} else {
					row.sumnum = parseFloat((parseFloat(row.onenum) * parseFloat(row.Number)).toFixed(2))
				}
				row.sumnum = parseFloat((parseFloat(row.Number) * parseFloat(row.onenum)).toFixed(2))
				row.TotalPrice = (parseFloat(row.sumnum) * parseFloat(row.ProPrice)).toFixed(2)
				row.YTotalPrice = (parseFloat(row.sumnum) * parseFloat(row.YProPrice)).toFixed(2)
				row.suntiji = (parseFloat(row.Number) * parseFloat(row.onetiji)).toFixed(2)
				for (var i = 0; i < this.peitiData.length; i++) {
					this.peitiData[i].sumnum = parseFloat((parseFloat(this.peitiData[i].Number) * parseFloat(
							this
							.peitiData[i]
							.onenum))
						.toFixed(2))
					this.peitiData[i].TotalPrice = (parseFloat(this.peitiData[i].sumnum) *
						parseFloat(this.peitiData[i].ProPrice)).toFixed(2)
					this.peitiData[i].YTotalPrice = (parseFloat(this.peitiData[i].sumnum) *
						parseFloat(this.peitiData[i].YProPrice)).toFixed(2)
					this.peitiData[i].suntiji = (parseFloat(this.peitiData[i].Number) * parseFloat(this
							.peitiData[i]
							.onetiji))
						.toFixed(2)
				}
			},
			//保存配提
			SavePeiti() {
				var that = this
				var hasnum = 0
				var selectionsum = 0
				var neednum = 0
				var Remarks = ""
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$refs.peititable.selection.forEach(el => {
					neednum = el.Sumstockbalance
					Remarks = el.Remarks
					el.spcode = null
					if (el.sumnum == 0) {
						hasnum = 1
						return
					}
					var issame = 0;
					for (var i = 0; i < this.ProList.length; i++) {
						if (this.ProList[i].ProductCode == el.ProductCode) {
							issame = 1
							break
						}
					}
					if (issame == 0) {
						el.Remarks = ""
						el.spcode = null
						selectionsum += parseFloat(el.sumnum)
						this.ProList.push(el)
					}
				})
				if (parseFloat(selectionsum) < parseFloat(neednum)) {
					loading.close();
					this.$message({
						message: '选择数量不够，请大于' + neednum,
						type: 'error'
					});
					return
				}
				if (hasnum == 1) {
					loading.close();
					this.$message({
						message: '请填写数量',
						type: 'error'
					});
					return
				}
				this.count()
				/* var sum = 0
				for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
						2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
				this.Info.Remark = Remarks
				this.peitiVisible = false
				if (this.peitiVisible == false) {
					//**//
					request({
						url: '/DRPORDERAPI.ashx?a=saveaddorder',
						method: 'Post',
						data: {
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							Info: JSON.stringify(this.Info),
							rows: JSON.stringify(this.ProList),
							ids: this.ids,
						}
					}).then(res => {
						if (res.code == 200) {
							loading.close();
							this.ProList = []
							this.Add = true
							this.hdAdd = true
							this.keyword = ""
							this.Hdkeyword = ""
							this.Info.spcode = null
							this.$emit("saveedAddOrder", res.data);
						} else {
							this.$message({
								message: res.info,
								type: 'error'
							});
							loading.close();
						}

						//this.$router.push('/order/order?F_OrderCode=' + res.data)
					})
				}
			},
			//

			//保存订单
			saveOrder() {
				this.saveloaing = true
				var haswl = 0;
				var haspj = 0;
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				if (this.ProList.length == 0) {
					this.$message({
						message: "请选择产品后再保存",
						type: 'error'
					});
					this.saveloaing = false
					loading.close();
					return
				}
				var pt = 0,
					hd = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					if (this.ProList[i].OrderType == "QX_TJ" && parseFloat(this.ProList[i].TJsum) > parseFloat(
							this
							.ProList[i]
							.sumnum)) {
						this.$message({
							message: this.ProList[i].ProductName + '的特价起订数量为' + this.ProList[i].TJsum,
							type: 'error'
						});
						this.saveloaing = false
						loading.close();
						return
					}

					if (this.ProList[i].OrderType == "QX_WL") {
						haswl++
					}
					if (this.ProList[i].OrderType == "QX_PJ") {
						haspj++
					}
					if (this.ProList[i].spcode == null || this.ProList[i].spcode == "" || this.ProList[i]
						.spcode ==
						undefined) {
						this.Info.spcode = null
						pt++
					} else {
						this.Info.spcode = this.ProList[i].spcode
						hd++
					}

					//this.ProList[i].lvprice = ""
				}
				if (pt > 0 && hd > 0) {
					this.$message({
						message: '活动商品无法与普通商品一起下单，请删除商品重新保存',
						type: 'error'
					});
					this.saveloaing = false
					loading.close();
					return
				}

				/*if (haspj != 0 && haspj != this.multipleSelection.length) {
					this.$message({
						message: '配件无法与其他产品一同下单',
						type: 'error'
					});
					return
				}
				if (haswl != 0 && haswl != this.multipleSelection.length) {
					this.$message({
						message: '物料无法与其他产品一同下单',
						type: 'error'
					});
					return
				}*/
				this.count()

				//大板
				request({
					url: '/DRPORDERAPI.ashx?a=checkdaban',
					method: 'Post',
					data: {
						//F_CustomerId: this.$store.state.user.F_CustomerId,
						rows: JSON.stringify(this.ProList),
					}
				}).then(res => {
					if (res == 1) {
						this.$confirm('蒙德里安系列大板根据所订产品中同一型号≥4<6块大板打包一个蜂窝包装箱，谢谢配合,帮您转到产品选择界面?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							loading.close();
							this.saveloaing = false
							if (this.Info.spcode == null || this.Info.spcode == "") {
								this.keyword = "包装箱"
								this.value = "QX_PT"
								this.OpenPro()
							} else {
								this.Hdkeyword = "包装箱"
								this.OpenHdPro()
							}
						}).catch(() => {
							loading.close();
							this.saveloaing = false
							return
						});
					} else {
						//配套
						if (this.issaved == 0) {
							request({
								url: '/DRPORDERAPI.ashx?a=beforesave',
								method: 'Post',
								data: {
									//F_CustomerId: this.$store.state.user.F_CustomerId,
									rows: JSON.stringify(this.ProList),
								}
							}).then(res => {
								if (res.data == 1) {
									request({
										url: '/DRPORDERAPI.ashx?a=checkpeiti',
										method: 'Post',
										data: {
											//F_CustomerId: this.$store.state.user.F_CustomerId,
											rows: JSON.stringify(this.ProList),
										}
									}).then(res => {
										if (res == null) {
											request({
												url: '/DRPORDERAPI.ashx?a=saveaddorder',
												method: 'Post',
												data: {
													//F_CustomerId: this.$store.state.user.F_CustomerId,
													Info: JSON.stringify(this
														.Info),
													rows: JSON.stringify(this
														.ProList),
													ids: this.ids,
												}
											}).then(res => {
												if (res.code == 200) {
													loading.close();
													this.saveloaing = false
													this.ProList = []
													this.Add = true
													this.hdAdd = true
													this.keyword = ""
													this.Hdkeyword = ""
													this.Info.spcode = null
													this.$emit(
														"saveedAddOrder",
														res.data);
												} else {
													this.$message({
														message: res
															.info,
														type: 'error'
													});
													loading.close();
													this.saveloaing = false
												}
												//this.$router.push('/order/order?F_OrderCode=' + res.data)
											})
										} else {
											this.saveloaing = false
											loading.close();
											this.peitiData = res.Rows
											this.tableheight = (document
												.documentElement
												.clientHeight -
												300) + "px"
											this.peitiVisible = true
										}
									})

								} else {
									this.saveloaing = false
									loading.close();
									this.ProMatch = res.data
									this.tableheight = (document.documentElement.clientHeight -
										300) + "px"
									//生成主件 配件 选择弹窗
									this.ProMatchVisible = true
								}
							})
						} else {
							request({
								url: '/DRPORDERAPI.ashx?a=checkpeiti',
								method: 'Post',
								data: {
									//F_CustomerId: this.$store.state.user.F_CustomerId,
									rows: JSON.stringify(this.ProList),
								}
							}).then(res => {
								if (res == null) {
									request({
										url: '/DRPORDERAPI.ashx?a=saveaddorder',
										method: 'Post',
										data: {
											//F_CustomerId: this.$store.state.user.F_CustomerId,
											Info: JSON.stringify(this.Info),
											rows: JSON.stringify(this.ProList),
											ids: this.ids,
										}
									}).then(res => {
										if (res.code == 200) {
											this.saveloaing = false
											loading.close();
											this.ProList = []
											this.Add = true
											this.hdAdd = true
											this.keyword = ""
											this.Hdkeyword = ""
											this.Info.spcode = null
											this.$emit("saveedAddOrder", res.data);
										} else {
											this.$message({
												message: res.info,
												type: 'error'
											});
											this.saveloaing = false
											loading.close();
										}
										//this.$router.push('/order/order?F_OrderCode=' + res.data)
									})
								} else {
									this.saveloaing = false
									loading.close();
									this.peitiData = res.Rows
									this.tableheight = (document.documentElement.clientHeight -
										300) + "px"
									this.peitiVisible = true
								}
							})
						}
						this.issaved = 1
					}
				})

			},
			//更改查询类型
			quanxian(val) {
				this.value = val
				this.pagination.page = 1
				this.onSubmit()
			},
			//查询商品
			onSubmit() {
				this.loading = 1
				request({
					url: '/DRPAPI.ashx?a=getpagelist',
					method: 'get',
					data: {
						pagination: JSON.stringify(this.pagination),
						queryJson: JSON.stringify({
							keyword: this.keyword,
							F_CategoryId: null,
							quanxian: this.value,
						})
					}
				}).then(res => {
					this.loading = 0
					this.pagination.page = res.data.page
					this.pagination.records = res.data.records
					this.pagination.total = res.data.total
					res.data.rows.forEach(item => {
						this.$set(item, "F_Disabled", false)
						if (item.F_Stock === null) {
							this.$set(item, "F_Stock", 0)
							this.$set(item, "num", 0)
						} else {
							this.$set(item, "num", 1)
						}
					})
					this.AddPro = res.data.rows

					var adddata = "";
					this.AddPro.forEach(item => {
						adddata += item.F_ProductCode + '@'
					})
					adddata = adddata.substring(0, adddata.length - 1)
					if (this.value == "QX_QD" || this.value == "QX_PT") {
						request({
							url: '/DRPORDERAPI.ashx?a=getlvpriceinfo',
							method: 'post',
							data: {
								F_ProductId: adddata,
								F_CustomerId: this.$store.state.user.F_CustomerId,
								OrderType: this.value
							}
						}).then(res => {
							for (var j = 0; j < this.AddPro.length; j++) {
								this.AddPro[j].lvprice = []
								for (var i = 0; i < res.data.length; i++) {

									if (this.AddPro[j].F_ProductCode == res.data[i].cinvcode) {
										this.AddPro[j].lvprice.push(res.data[i])
									}
								}
							}
							for (var i = 0; i < this.AddPro.length; i++) {
								for (var j = 0; j < this.AddPro[i].lvprice.length; j++) {
									if (this.value == "QX_QD") {
										if (this.AddPro[i].lvprice[j].lvwhere != '' && this
											.AddPro[i]
											.num >=
											Math.ceil(this.AddPro[i].lvprice[j].lvwhere /
												this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].lvprice[j]
												.lvprice
											break
										} else if (this.AddPro[i].num < Math.ceil(this.AddPro[
													i].lvprice[j]
												.lvwhere / this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].QD_Price
											break
										}

									}
									if (this.value == "QX_PT") {
										if (this.AddPro[i].lvprice[j].lvwhere != '' && this
											.AddPro[i]
											.num >=
											Math.ceil(this.AddPro[i].lvprice[j].lvwhere /
												this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].lvprice[j]
												.lvprice
											break
										} else if (this.AddPro[i].num < Math.ceil(this.AddPro[
													i].lvprice[j]
												.lvwhere / this.AddPro[i].F_UnitRate)) {
											this.AddPro[i].price = this.AddPro[i].PT_Price
											break
										}

									}
								}
							}
						})
					} else if (this.value == "QX_TJ" || this.value == "QX_PT") {
						for (var i = 0; i < this.AddPro.length; i++) {
							if (this.AddPro[i].QX_TJ && this.AddPro[i].TJsum <= (this.AddPro[i]
									.F_UnitRate * this
									.AddPro[i].num)) {
								this.AddPro[i].price = this.AddPro[i].TJ_Price
							} else {
								this.AddPro[i].price = this.AddPro[i].PT_Price
							}
						}
					}
				})

			},
			onHdSubmit() {
				this.loading = 1
				request({
					url: '/DRPORDERAPI.ashx?a=gethdpagelist',
					method: 'POST',
					data: {
						hdpagination: JSON.stringify(this.Hdpagination),
						hdqueryJson: JSON.stringify({
							keyword: this.Hdkeyword,
						})
					}
				}).then(res => {
					this.loading = 0
					this.AddHdPro = res.data.rows
					this.Hdpagination.page = res.data.page
					this.Hdpagination.records = res.data.records
					this.Hdpagination.total = res.data.total
					var adddata = "";
					this.AddHdPro.forEach(item => {
						adddata += item.F_ProductCode + '@'
					})
					adddata = adddata.substring(0, adddata.length - 1)
					request({
						url: '/DRPORDERAPI.ashx?a=gethdlvpriceinfo',
						method: 'post',
						data: {
							F_ProductId: adddata,
							F_CustomerId: this.$store.state.user.F_CustomerId,
						}
					}).then(res => {
						for (var j = 0; j < this.AddHdPro.length; j++) {
							this.AddHdPro[j].lvprice = []
							for (var i = 0; i < res.data.length; i++) {
								if (this.AddHdPro[j].F_ProductCode == res.data[i].cinvcode) {
									this.AddHdPro[j].lvprice.push(res.data[i])
								}
							}
							for (var i = this.AddHdPro[j].lvprice.length - 1; i >= 0; i--) {
								if (this.AddHdPro[j].num >= Math.ceil(this.AddHdPro[j].lvprice[
											i].lvwhere /
										this.AddHdPro[j].F_UnitRate)) {
									this.AddHdPro[j].price = this.AddHdPro[j].lvprice[i]
										.lvprice
									break;
								}
							}
						}

					})
				})
			},
			OpenProxuanze() {

				if (this.ProList.length == 0) {
					if (this.ishd) {
						this.$confirm('如有蒙德里安大板---集采帐户余额请点击集采商品下单，请选择?', '提示', {
							confirmButtonText: '大板集采下单',
							cancelButtonText: '常规下单',
							type: 'warning'
						}).then(() => {
							this.OpenHdPro();
						}).catch(() => {
							this.OpenPro();
						});
					} else {
						this.OpenPro();
					}
				} else {
					{
						if (this.ProList[0].spcode == "" || this.ProList[0].spcode == null || this.ProList[0]
							.spcode ==
							undefined) {
							this.OpenPro();
						} else {
							this.OpenHdPro();
						}
					}

				}

			},
			//打开选择商品对话框
			OpenPro() {

				this.loading = 1
				this.ProVisible = true
				this.tableheight = (document.documentElement.clientHeight - 240) + "px"
				this.pagination.page = 1
				this.onSubmit()


			},
			OpenHdPro() {
				this.loading = 1
				this.HdProVisible = true
				this.tableheight = (document.documentElement.clientHeight - 240) + "px"
				this.Hdpagination.page = 1
				this.onHdSubmit()
			},
			//更改产品数量
			changenum(val) {
				var sum = val.num * val.F_UnitRate

				if (val.QX_TJ && val.TJsum != null) {
					if (val.value == "QX_TJ" && sum < val.TJsum) {
						this.value = 'QX_PT'
						val.price = val.PT_Price
						this.count()
					} else if (this.value == "QX_PT" && sum >= val.TJsum) {

						this.$confirm('该商品拥有特价，特价起订量为' + Math.ceil(val.TJsum / val.F_UnitRate) +
							'件，是否需要将下单类型转成特价?',
							'提示', {
								confirmButtonText: '转成特价',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
							this.value = 'QX_TJ'
							val.price = val.TJ_Price
							this.count()
						}).catch(() => {
							val.price = val.PT_Price
							this.count()
						});
					} else if (this.value == "QX_TJ" && sum >= val.TJsum) {
						val.price = val.TJ_Price
						this.count()
					}

				}

				if (this.value == "QX_QD") {
					val.price = val.QD_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}
				if (this.value == "QX_PT") {
					val.price = val.PT_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}
				this.count()


				/*if (this.value == "QX_QD") {
					for (var i = 0; i < this.AddPro.length; i++) {
						var change = 0;
						if (val.F_ProductId == this.AddPro[i].F_ProductId) {
							for (var j = this.AddPro[i].lvprice.length - 1; j >= 0; j--) {
								if (val.num >= Math.ceil(this.AddPro[i].lvprice[j].lvwhere / this.AddPro[i].F_UnitRate)) {
									this.AddPro[i].price = this.AddPro[i].lvprice[j].lvprice
									change = 1
									break;
								}
							}
							if (change == 0) {
								this.AddPro[i].price = this.AddPro[i].yprice
							}
						}
					}
				}
				console.log(this.value)
				if (this.value == 'QX_TJ') {
					for (var i = 0; i < this.AddPro.length; i++) {
						if (this.AddPro[i].TJsum > (this.AddPro[i].F_UnitRate * this.AddPro[i].num)) {
							this.AddPro[i].price = this.AddPro[i].PT_Price
						} else {
							this.AddPro[i].price = this.AddPro[i].TJ_Price
						}
					}
				}*/
			},
			//更改活动产品
			changehdnum(row) {
				if (row.lvprice != "") {
					row.price = row.PT_Price
					row.yprice = row.PT_Price
					for (var j = row.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (row.num >= Math.ceil(row.lvprice[j].lvwhere / row.F_UnitRate)) {
							row.price = row.lvprice[j].lvprice
							row.yprice = row.lvprice[j].lvprice
							break;
						}
					}
				}
			},
			//选择活动产品
			SaveHdPro(row) {
				row.F_Disabled = true
				var same = 0;
				var that = this
				for (var j = 0; j < this.ProList.length; j++) {
					if (this.ProList[j].ProductCode == row.F_ProductCode && row.F_ProductName.indexOf("定制画") ==
						-1) {
						same = 1
						this.$message({
							message: '已有相同产品，无法添加。修改数量请在订单中修改。',
							type: 'error'
						});
						row.F_Disabled = false
						break;
					}
				}
				var totalprice = row.num * row.F_UnitRate * parseFloat(row.price)
				if (same == 0) {
					this.$message({
						message: '添加成功',
						type: 'success'
					});
					var data = {
						ProductCode: row.F_ProductCode,
						ProductName: row.F_ProductName,
						Standard: row.F_SpecText,
						Unit: row.F_UnitText,
						stdd: row.整件规格,
						onenum: row.F_UnitRate,
						Number: row.num,
						sumnum: row.num * row.F_UnitRate,
						YProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
						ProPrice: parseFloat(parseFloat(row.price).toFixed(2)),
						TotalPrice: (totalprice).toFixed(2),
						YTotalPrice: (totalprice).toFixed(2),
						onetiji: row.onetiji == null ? 0 : parseFloat(row.onetiji).toFixed(2),
						suntiji: row.onetiji == null ? 0 : parseFloat(parseFloat(row.onetiji) * parseFloat(
								row.num) *
							parseFloat(row.F_UnitRate)
							.toFixed(
								2)),
						Remarks: "",
						Protype: row.商品属性,
						oldcode: row.老编码,
						isCX: row.isCX,
						lvprice: row.lvprice,
						filepath: row.filepath,
						filetype: row.filetype,
						filename: row.filename,
						PT_Price: parseFloat(parseFloat(row.price).toFixed(2)),
						spcode: row.spcode.toString(),
						OrderType: "QX_HD",
						TJsum: row.TJsum,
						整件规格: row.整件规格,

					}

					if (data.YProPrice == undefined || data.YProPrice == "" || data.YProPrice == null || isNaN(
							data
							.YProPrice)) {
						this.$message.error("网络错误，请重新选入产品")
						return false
					}
					this.ProList.push(data)
					this.Add = false
					this.ishd = true
					row.F_Disabled = false
					var sum = 0
					for (var i = 0; i < this.ProList.length; i++) {
						this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(
							this.ProList[
								i]
							.onenum)).toFixed(
							2))
						this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this
							.ProList[i]
							.ProPrice)).toFixed(
							2)
						this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this
							.ProList[i]
							.YProPrice)).toFixed(
							2)
						this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this
								.ProList[i]
								.onetiji))
							.toFixed(2)
						sum += parseFloat(this.ProList[i].TotalPrice)
					}
					this.Info.TotalMoney = parseFloat(sum.toFixed(2))
					this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney))
						.toFixed(2)
				}
			},
			//选择产品
			SavePro(row) {
				row.F_Disabled = true
				var same = 0;
				var that = this
				for (var j = 0; j < this.ProList.length; j++) {
					if (this.ProList[j].ProductCode == row.F_ProductCode && row.F_ProductName.indexOf("定制画") ==
						-1) {
						same = 1
						this.$message({
							message: '已有相同产品，无法添加。修改数量请在订单中修改。',
							type: 'error'
						});
						row.F_Disabled = false
						break;
					}
				}
				var totalprice = row.num * row.F_UnitRate * parseFloat(row.price)
				if (same == 0) {
					this.$message({
						message: '添加成功',
						type: 'success'
					});
					request({
						url: '/DRPORDERAPI.ashx?a=getaddproinfo',
						method: 'get',
						data: {
							F_ProductId: row.F_ProductCode,
							//F_CustomerId: this.$store.state.user.F_CustomerId,
							OrderType: this.value,
							price: row.price,
						}
					}).then(res => {
						var data = {
							ProductCode: res.data.ProductCode,
							ProductName: res.data.ProductName,
							Standard: res.data.Standard,
							Unit: res.data.Unit,
							stdd: res.data.stdd,
							onenum: parseFloat(parseFloat(res.data.onenum).toFixed(2)),
							Number: parseFloat(row.num).toFixed(0),
							sumnum: parseFloat(parseFloat(row.num * res.data.onenum).toFixed(2)),
							YProPrice: parseFloat(row.price).toFixed(2),
							ProPrice: parseFloat(row.price).toFixed(2),
							TotalPrice: (totalprice).toFixed(2),
							YTotalPrice: (totalprice).toFixed(2),
							onetiji: res.data.onetiji == null ? 0 : parseFloat(res.data.onetiji)
								.toFixed(2),
							suntiji: res.data.onetiji == null ? 0 : parseFloat(parseFloat(res.data
									.onetiji) *
								parseFloat(row.num) *
								parseFloat(res.data.onenum).toFixed(
									2)),
							Remarks: "",
							Protype: res.data.Protype,
							oldcode: res.data.oldcode,
							isCX: res.data.isCX,
							lvprice: row.lvprice,
							filepath: row.filepath,
							filetype: row.filetype,
							filename: row.filename,
							QX_DS: res.data.QX_DS,
							QX_PJ: res.data.QX_PJ,
							QX_PT: res.data.QX_PT,
							QX_QD: res.data.QX_QD,
							QX_TJ: res.data.QX_TJ,
							QX_WL: res.data.QX_WL,
							QX_YT: res.data.QX_YT,
							PT_Price: res.data.PT_Price,
							QD_Price: res.data.QD_Price,
							DS_Price: res.data.DS_Price,
							TJ_Price: res.data.TJ_Price,
							WL_Price: res.data.WL_Price,
							PJ_Price: res.data.PJ_Price,
							OrderType: res.data.OrderType,
							TJsum: row.TJsum,
							整件规格: row.整件规格,
							spcode: null,
							Protype: row.商品属性
						}
						if (res.data.yuanjia == undefined || res.data.yuanjia == "" || res.data
							.yuanjia == null ||
							isNaN(res
								.data.yuanjia)) {
							this.$message.error("网络错误，请重新选入产品")
							return false
						}

						this.ProList.push(data)
						this.hdAdd = false
						this.ishd = false
						row.F_Disabled = false
						var sum = 0
						for (var i = 0; i < this.ProList.length; i++) {
							if (this.ProList[i].OrderType == 'QX_TJ') {
								if (this.ProList[i].TJsum > this.ProList[i].sumnum) {
									this.ProList[i].ProPrice = this.ProList[i].PT_Price
									//this.ProList[i].OrderType='QX_PT'
								} else {
									this.ProList[i].ProPrice = this.ProList[i].TJ_Price
									//this.ProList[i].OrderType='QX_TJ'
								}
							}


							this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) *
								parseFloat(
									this
									.ProList[i].onenum)).toFixed(
								2))
							this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) *
								parseFloat(this
									.ProList[
										i].ProPrice)).toFixed(
								2)
							this.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) *
								parseFloat(this
									.ProList[i].YProPrice)).toFixed(
								2)
							this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(
									this
									.ProList[i]
									.onetiji))
								.toFixed(2)
							sum += parseFloat(this.ProList[i].TotalPrice)
						}
						this.Info.TotalMoney = parseFloat(sum.toFixed(2))
						this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info
								.flmoney))
							.toFixed(2)

					})
				}

			},
			//关闭对话框
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			//订单详情获取
			OrderDetail() {
				this.loading = 1

				var ids = this.ids
				var proValue = this.proValue
				if (ids == "" || ids == undefined) {
					ids = ''
					proValue = ''
				}

				request({
					url: '/DRPORDERAPI.ashx?a=getaddorder',
					method: 'POST',
					data: {
						id: ids,
						pro: proValue
						//F_CustomerId: this.$store.state.user.F_CustomerId
					}
				}).then(res => {
					this.loading = 0
					this.ProList = res.data.list
					this.Info = res.data.info
					this.ishd = res.data.ishd
					this.Yishd = res.data.ishd
					for (var i = 0; i < this.ProList.length; i++) {
						this.ProList[i].Number = parseFloat(this.ProList[i].Number)
						this.ProList[i].sumnum = parseFloat(this.ProList[i].sumnum)
						if (this.ProList[i].spcode == "" || this.ProList[i].spcode == null) {
							this.Info.spcode = null
							this.Add = true
							this.hdAdd = false
						}
						if (this.ProList[i].OrderType == 'QX_QD') {
							for (var j = this.ProList[i].lvprice.length - 1; j >= 0; j--) {
								if (this.ProList[i].Number >= Math.ceil(this.ProList[i].lvprice[j]
										.lvwhere / this
										.ProList[i].onenum)) {
									this.ProList[i].ProPrice = this.ProList[i].lvprice[j].lvprice
									this.ProList[i].YProPrice = this.ProList[i].lvprice[j].lvprice
									this.ProList[i].YTotalPrice = Math.round(this.ProList[i].lvprice[j]
										.lvprice *
										this
										.ProList[i].Number * this.ProList[i].onenum, 2)
									this.ProList[i].TotalPrice = Math.round(this.ProList[i].lvprice[j]
										.lvprice *
										this
										.ProList[i].Number * this.ProList[i].onenum, 2)
									break;
								}
							}
						}
						if (this.ProList[i].OrderType == 'QX_PT') {
							for (var j = this.ProList[i].lvprice.length - 1; j >= 0; j--) {
								if (this.ProList[i].Number >= Math.ceil(this.ProList[i].lvprice[j]
										.lvwhere / this
										.ProList[i].onenum)) {
									this.ProList[i].ProPrice = this.ProList[i].lvprice[j].lvprice
									this.ProList[i].YProPrice = this.ProList[i].lvprice[j].lvprice
									this.ProList[i].YTotalPrice = Math.round(this.ProList[i].lvprice[j]
										.lvprice *
										this
										.ProList[i].Number * this.ProList[i].onenum, 2)
									this.ProList[i].TotalPrice = Math.round(this.ProList[i].lvprice[j]
										.lvprice *
										this
										.ProList[i].Number * this.ProList[i].onenum, 2)
									break;
								}
							}
						}

					}
				})
			},
			//产品分页
			handleSizeChange(newSize) {
				this.pagination.rows = newSize;
				this.onSubmit();
			},
			handleCurrentChange(newPage) {
				this.pagination.page = newPage;
				this.onSubmit();
			},
			hdhandleSizeChange(newSize) {
				this.Hdpagination.rows = newSize;
				this.onHdSubmit()();
			},
			hdhandleCurrentChange(newPage) {
				this.Hdpagination.page = newPage;
				this.onHdSubmit();
			},
			//更改数量
			detailEdit(row, colname) {

				if (colname == "sumnum") {
					if (Math.floor(row.sumnum) == 0) {
						row.sumnum = 1
					}
					if (row.sumnum  % 1 != 0 &&row.Unit!="米" &&row.Unit!="平方米") {
						
						this.$message.error("数量只能输入整数!")
						row.sumnum = Math.floor(row.sumnum );
					}
					else
					{
						
						row.sumnum =parseFloat(parseFloat(row.sumnum).toFixed(2));
						
					}
					row.Number = row.sumnum / row.onenum
				}
				if (colname == "Number") {
					var num = parseFloat(row.Number);
					if (Math.floor(row.Number) == 0) {
						row.Number = 1
					}
					if (num % 1 != 0 &&row.Unit!="米" &&row.Unit!="平方米") {
						
						this.$message.error("件数只能输入整数!")
						row.Number = Math.floor(num);
					}else
					{
						
						row.Number = parseFloat( num.toFixed(2));
						
					}
				}
				// var num = Math.floor(row.Number)
				// if (num == 0) {
				// 	row.Number = 1
				// 	num = 1
				// }
				var code = row.ProductCode
				var type = row.OrderType
				//var sum = 0;
				var change = 0
				if (row.QX_TJ == "True") {
					if (type == "QX_TJ" && row.Number * row.onenum < row.TJsum) {
						row.OrderType = 'QX_PT'
						row.ProPrice = row.PT_Price
						this.count()
					} else if (type == "QX_PT" && row.Number * row.onenum >= row.TJsum) {
						//if (row.isremind != 1 && row.TJsum != undefined) {
						this.$confirm('该商品拥有特价，特价起订量为' + Math.ceil(row.TJsum / row.onenum) +
							'件，是否需要将下单类型转成特价?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
							row.OrderType = 'QX_TJ'
							row.ProPrice = row.TJ_Price
							//this.$set(row, 'isremind', 1)
							this.count()
						}).catch(() => {
							row.ProPrice = row.PT_Price
							//this.$set(row, 'isremind', 1)
							this.count()
						});
						//}
					} else if (type == "QX_TJ" && row.Number * row.onenum >= row.TJsum) {
						row.ProPrice = row.TJ_Price
						this.count()
					}
				}

				if (row.QX_QD == "True" || (row.spcode != null && row.spcode != undefined && row.spcode !=
						"")) {
					if (type == "QX_QD" || (row.spcode != null && row.spcode != undefined && row.spcode !=
							"")) {
						for (var j = row.lvprice.length - 1; j >= 0; j--) {
							if (row.Number >= Math.ceil(row.lvprice[j].lvwhere / row.onenum)) {
								row.ProPrice = row.lvprice[j].lvprice
								change = 1
								break;
							}
						}
						if (change == 0) {
							row.ProPrice = row.QD_Price
						}
						if ((row.spcode != null && row.spcode != undefined && row.spcode != "") && change ==
							0) {
							row.ProPrice = row.PT_Price
						}
					}
				}
				if (row.QX_PT == "True" || (row.spcode != null && row.spcode != undefined && row.spcode !=
						"")) {
					if (type == "QX_PT" || (row.spcode != null && row.spcode != undefined && row.spcode !=
							"")) {
						for (var j = row.lvprice.length - 1; j >= 0; j--) {
							if (row.Number >= Math.ceil(row.lvprice[j].lvwhere / row.onenum)) {
								row.ProPrice = row.lvprice[j].lvprice
								change = 1
								break;
							}
						}
						if (change == 0) {
							row.ProPrice = row.PT_Price
						}
						if ((row.spcode != null && row.spcode != undefined && row.spcode != "") && change ==
							0) {
							row.ProPrice = row.PT_Price
						}
					}
				}
				this.count()
				/* for (var i = 0; i < this.ProList.length; i++) {
					if (this.ProList[i].ProductCode == code) {
						this.ProList[i].Number = num
						this.ProList[i].ProPrice = row.ProPrice
						this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
							2))
						this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(
							2)
						this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
							2)
					}
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
			},
			//更改产品属性
			OrderTypeChange(row) {
				if (row.OrderType == "QX_PT") {
					row.YProPrice = row.PT_Price
					row.ProPrice = row.PT_Price
				} else if (row.OrderType == "QX_TJ") {
					if (row.TJsum > row.sumnum) {
						row.YProPrice = row.PT_Price
						row.ProPrice = row.PT_Price
						//row.OrderType='QX_PT'
					} else {
						row.YProPrice = row.TJ_Price
						row.ProPrice = row.TJ_Price
						//row.OrderType='QX_TJ'
					}
					//row.YProPrice = row.TJ_Price
				} else if (row.OrderType == "QX_DS") {
					row.YProPrice = row.DS_Price
					row.ProPrice = row.DS_Price
				} else if (row.OrderType == "QX_QD") {
					row.YProPrice = row.QD_Price
					row.ProPrice = row.QD_Price
					for (var j = row.lvprice.length - 1; j >= 0; j--) {
						if (row.ProductCode == row.ProductCode) {
							if (parseInt(row.Number * row.onenum) >= parseInt(row.lvprice[j].lvwhere)) {
								row.YProPrice = row.lvprice[j].lvprice
								row.ProPrice = row.lvprice[j].lvprice
								break;
							}
						}
					}
				} else if (row.OrderType == "QX_WL") {
					row.yYProPrice = row.WL_Price
					row.ProPrice = row.WL_Price
				} else if (row.OrderType == "QX_PJ") {
					row.YProPrice = row.PJ_Price
					row.ProPrice = row.PJ_Price
				}
				this.count()

				/* var sum = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					if (this.ProList[i].OrderType == "QX_PT") {
						this.ProList[i].ProPrice = this.ProList[i].PT_Price
					} else if (this.ProList[i].OrderType == "QX_TJ") {
						if(this.ProList[i].TJsum>this.ProList[i].sumnum){
							this.ProList[i].YProPrice=this.ProList[i].PT_Price
							this.ProList[i].ProPrice=this.ProList[i].PT_Price
							//this.ProList[i].OrderType='QX_PT'
						}else{
							this.ProList[i].YProPrice=this.ProList[i].TJ_Price
							this.ProList[i].ProPrice=this.ProList[i].TJ_Price
							//this.ProList[i].OrderType='QX_TJ'
						}
						//this.ProList[i].ProPrice = this.ProList[i].TJ_Price
					} else if (this.ProList[i].OrderType == "QX_DS") {
						this.ProList[i].ProPrice = this.ProList[i].DS_Price
					} else if (this.ProList[i].OrderType == "QX_QD") {
						this.ProList[i].ProPrice = this.ProList[i].QD_Price
						for (var j = this.ProList[i].lvprice.length - 1; j >= 0; j--) {
							//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
							if (this.ProList[i].Number >= Math.ceil(this.ProList[i].lvprice[j].lvwhere/this.ProList[i].F_UnitRate)) {
								this.ProList[i].ProPrice = this.ProList[i].lvprice[j].lvprice
								break;
							}
						}
					} else if (this.ProList[i].OrderType == "QX_WL") {
						this.ProList[i].ProPrice = this.ProList[i].WL_Price
					} else if (this.ProList[i].OrderType == "QX_PJ") {
						this.ProList[i].ProPrice = this.ProList[i].PJ_Price
					}

					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					his.ProList[i].YTotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
						2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
			},
			//删除产品
			deletePro(code) {
				//var sum = 0;
				for (var i = 0; i < this.ProList.length; i++) {
					if (code == this.ProList[i]) {
						this.delPro.push(this.ProList[i])
						this.ProList.splice(i, 1)
						break;
					}

				}
				if (this.ProList.length == 0) {
					this.hdAdd = true
					this.Add = true
					this.ishd = this.Yishd
					this.Hdkeyword = ""
					this.keyword = ""
					this.Info.spcode = null
				}

				this.count()
				/* for (var i = 0; i < this.ProList.length; i++) {
					this.ProList[i].sumnum = parseFloat((parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onenum)).toFixed(
						2))
					this.ProList[i].TotalPrice = (parseFloat(this.ProList[i].sumnum) * parseFloat(this.ProList[i].ProPrice)).toFixed(2)
					this.ProList[i].suntiji = (parseFloat(this.ProList[i].Number) * parseFloat(this.ProList[i].onetiji)).toFixed(
						2)
					sum += parseFloat(this.ProList[i].TotalPrice)
				}
				this.Info.TotalMoney = parseFloat(sum.toFixed(2))
				this.Info.paymoney = (parseFloat(this.Info.TotalMoney) - parseFloat(this.Info.flmoney)).toFixed(2) */
			},
			//总计
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index === 3 || index === 4 || index === 6) {
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + curr;
								} else {
									return prev;
								}
							}, 0);
							sums[index] = parseFloat(parseFloat(sums[index]).toFixed(2))
						}
					}
				});
				return sums;
			},
		},
		filters: {
			showPrice(price) {
				//alert (price)
				if (!price) return '0.00';
				var intPart = Number(price) - Number(price) % 1; //获取整数部分
				var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

				var floatPart = ".00"; //预定义小数部分
				var value2Array = price.toString().split(".");

				//=2表示数据有小数位
				if (value2Array.length == 2) {
					floatPart = value2Array[1].toString(); //拿到小数部分

					if (floatPart.length == 1) {
						return '¥' + intPartFormat + "." + floatPart + '0';
					} else {
						return '¥' + intPartFormat + "." + floatPart.substring(0, 2);
					}

				} else {
					return '¥' + intPartFormat + floatPart;
				}

			}
		}
	}
</script>
<style>
	.el-card__body {
		padding: 5px !important;

	}

	.el-dialog__body {
		padding: 5px !important;

	}

	.el-table--striped .el-table__body tr.el-table__row--striped td {
		background: #eeeeee;
	}
</style>
<style scoped>
	@import "../../font/iconfont.css";

	@font-face {
		font-family: 'iconfont';
		src: url('../../font/iconfont.eot');
		src: url('../../font/iconfont.eot?#iefix') format('embedded-opentype'),
			url('../../font/iconfont.woff2') format('woff2'),
			url('../../font/iconfont.woff') format('woff'),
			url('../../font/iconfont.ttf') format('truetype'),
			url('../../font/iconfont.svg#iconfont') format('svg');
	}

	.el-dialog__body {
		padding: 0px 0px !important;

	}

	.el-textarea__inner {
		min-height: 50px !important;
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 12px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.img {
		width: 100px;
		height: 100px;
	}

	.l {
		display: block;
		margin-top: 10px;
	}

	/* .l3 {
		font-size: 16px;
		font-weight: 700;
	} */

	.flow {
		width: 50px;
		height: 50px;
		position: absolute;
		background: #e7093d;
		top: -50px;
		right: -50px;
		transform: rotate(45deg);
	}

	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}

	* {
		font-size: 12px;
		font-family: "Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", 华文细黑, STHeiti, MingLiu
	}

	.el-form-item {
		margin-bottom: 5px !important;
	}

	.el-breadcrumb {
		font-size: 12px;
		line-height: 1;
		margin-top: -20px;
	}

	.el-button--mini {
		padding: 5px 10px !important;
	}

	.cell {
		line-height: 2 !important;
	}

	.el-dialog__header {
		display: none !important;
	}
</style>
